export const projectRoutes = {
  projectDetails: '/',
  editProject: '/edit',
  newQuote: '/quotes/new',
  viewOrEditQuote: '/quotes/:quoteId',
  newQuoteRevision: '/quotes/:quoteId/new-revision',
  viewOrEditQuoteBillOfMaterials: '/quotes/:quoteId/bill-of-materials',
  viewQuoteHandoverPack: '/quotes/:quoteId/handover-pack',
  viewDesignHandoverPack: '/designs/:designId/handover-pack',
  newDesignFromQuote: '/quotes/:quoteId/create-design',
  editDesign: '/designs/:designId/edit',
  newDesignRevision: '/designs/:designId/new-revision',
  viewOrEditDesignBillOfMaterials: '/designs/:designId/bill-of-materials',
  manifoldDiagramPdf: '/designs/:designId/units/:unitId/pdf',
  editPdfDetails: '/designs/:designId/units/:unitId/pdf/edit',
  dataForDesignDrawings: '/designs/:designId/data-for-design-drawings',
};
